import { Transition } from '@headlessui/react';
import classNames from 'classnames';
import { BiSearchAlt } from 'react-icons/bi';
import { IoClose } from 'react-icons/io5';
import Button, { IconButton } from '../../Button';
import TextInput from '../../FormFields/TextInput';

export default function EntitiesSearch({
  searchQuery,
  handleSearchChange,
  isFilterOpen,
  showEndButton,
  onFilter,
  handleReset,
  autoFocus,
  placeholder = 'Filter messages',
  inputClassName,
}) {
  const filterClasses = classNames('filter', {
    open: isFilterOpen,
    closed: !isFilterOpen,
  });

  const inputClasses = classNames('filter-search-input', inputClassName, {
    open: isFilterOpen,
    closed: !isFilterOpen,
  });

  const searchClasses = classNames('filter-search', {
    'filter-search-open': isFilterOpen,
  });

  return (
    <form onSubmit={(e) => e.preventDefault()} className={filterClasses}>
      <section className="f-container">
        <TextInput
          className="wrapper"
          inputClasses={inputClasses}
          placeholder={placeholder}
          value={searchQuery}
          onChange={handleSearchChange}
          type="search"
          startButton={
            <section>
              <IconButton
                ariaHidden={!!isFilterOpen}
                tabIndex={isFilterOpen ? -1 : ''}
                className={searchClasses}
                onClick={() => {
                  if (onFilter && !isFilterOpen) {
                    onFilter();
                  }
                }}
              >
                <BiSearchAlt className="icon" />
                <span className="sr-only">Search</span>
              </IconButton>
            </section>
          }
          endButton={
            <section className="flex items-center">
              <Transition
                show={showEndButton}
                enter="transform transition duration-300"
                enterFrom="opacity-0 rotate-[-120deg]"
                enterTo="opacity-1000 rotate-0"
                leave="transform transition"
                leaveFrom="opacity-100 rotate-0"
                leaveTo="opacity-0 rotate-[-120deg]"
              >
                <IconButton variant="clear" className="filter-close" onClick={handleReset}>
                  <span className="sr-only">Clear</span>
                  <IoClose className="icon" />
                </IconButton>
                <Button
                  className="sr-only"
                  disabled={!searchQuery}
                  variant="clear"
                  size="small"
                  type="submit"
                >
                  Search
                </Button>
              </Transition>
            </section>
          }
          autoFocus={autoFocus}
        />
      </section>
    </form>
  );
}
